<div class="flex flex-justify-center">
    <div class="w-9 w-11-s bg-col-5 p-a-8">
        <!-- title -->
        <h2 class="w-12 h2 center m-b-1"
            *iCms="'title' of component"></h2>

        <!-- subtitle -->
        <span class="w-12 p1 center m-b-2"
              *iCms="'subtitle' of component"></span>

        <!-- calculator -->
        <div class="center">
            <form class="w-5 w-9-l w-12-s"
                  method="POST"
                  name="klarna"
                  #form="ngForm">
                <div class="pos-relative">
                    <input-wrap [canShowValidate]="true">
                        <div class="form-highlight-label">
                            <input class="input"
                                   name="value"
                                   type="text"
                                   pattern="[0-9]*"
                                   inputmode="numeric"
                                   [muiInput]="'Enter basket value' | translate"
                                   [(ngModel)]="basketValue"
                                   (ngModelChange)="updateCalculation(basketValue)">
                        </div>
                    </input-wrap>
                </div>
            </form>
        </div>
        @if (basketValue) {
        <div class="center m-t-3">
            <div class="w-5 w-9-l w-12-s">
                <h5 class="p3 center m-b">{{'Repay over 12 months' | translate}}</h5>
                @if (!!calculation) {
                <div class="w-12 p1">
                    <p class="flex flex-justify-between">
                        {{'11 payments of' | translate}}
                        <price [value]="calculation.monthPayment" />
                    </p>
                    <p class="flex flex-justify-between">
                        {{'Final payment of' | translate}}
                        <price [value]="calculation.lastPayment" />
                    </p>
                    <p class="flex flex-justify-between">
                        {{'Total payable' | translate}}
                        <price [value]="calculation.total"
                               [precision]="2" />
                    </p>
                </div>
                } @else {
                <div class="center m-t-3">
                    <p class="p1 fw-bold m-b-1">{{'Unavailable' | translate}}</p>
                    <p>
                        {{'Available for orders worth' | translate}}&nbsp;
                        <price [value]="minValue" />&nbsp;
                        {{'or more' | translate}}.
                    </p>
                </div>
                }
            </div>
        </div>
        }
    </div>
</div>